import { Fragment, FC } from "react";

const Organization: FC<{ color: string }> = ({ color = "white" }) => {
  return (
    <Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7051 22.0494H18.2949V18.6684H21.7985V14.2393H18.2949V10.8583H13.7051V14.2393H10.2015V18.6684H13.7051V22.0494ZM4 28V10.6554L15.9825 2L28 10.6667V28H4Z"
          fill={color}
        />
      </svg>
    </Fragment>
  );
};

export default Organization;
